import React from "react";
import LogOutUser from "components/account/log-out";
import { DirectLink } from "components/link-types";
import { useSelector } from "react-redux";
import Link from "helpers/link";
import { ReactComponent as User } from "assets/svgs/user.svg";
import { IconLink } from "components/link-types";
import { useGlobalContext } from "context/global";
import Image from "components/image";

export const UserStatus = ({ customerLinks, path }) => {
	const { authenticated, firstName, lastName } = useSelector((state) => state.account.profile);
	const { translation, } = useGlobalContext();

	if (authenticated) {
		return( 
			<div className="group text-center whitespace-nowrap relative mr-2">
				<Link to="/account/subscription" className="group-hover:border-2 border-brown pt-1 pr-6 pl-5 rounded-3xl border flex items-center">
					<span className="[transform:translateZ(0)]"><User className="scale-[0.78] user-icon mb-1 mr-1" /></span>
					<span className="block text-lg">{firstName || lastName} </span>
				</Link>
			
				<div className="absolute opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out pointer-events-none group-hover:pointer-events-auto shadow-lg bg-white w-max px-4 py-10 rounded-[1.25rem] -left-2">
					{customerLinks.map((link) =>
						link._type === "iconLink" ? 
							<IconLink key={link?.key} link={link} path={path} className="!py-0 mt-3 px-4 text-lg"/>
							: <LogOutUser icon key={link?._key} text={link?.title} textColor={link.color?.hex}
								className="mt-3 px-4 block text-lg hover:underline"/>)}
				</div>
			</div>
		);
	}

	return (
		<Link to="/account/login" className="border-brown py-0 pt-1 pr-6 pl-5 rounded-3xl border flex items-center">
			<User className="scale-[0.78] user-icon md:mb-1 md:mr-1" />
			<span className="hidden md:block">{translation.other?.login}</span>
		</Link>
	);
};

const DesktopHeaderData = ({ data, advertisement }) => {
	if (!data?.length) return <></>;
	const { authenticated } = useSelector((state) => state.account.profile);

	const GroupLinks = ({ data, advertisement }) => (
		<div className="group text-center whitespace-nowrap">
			<Link to={data?.url}>
				<p title={data.title} className="nav-link group-hover:font-boldParagraph">{data.title}</p>
			</Link>
	
			<div className="absolute -left-32  opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out pointer-events-none group-hover:pointer-events-auto top-full bg-white w-screen shadow-lg">
				<div className="ml-[7.5rem] p-4 flex justify-between">
					<div>
						{data.groupLinkData.map((link) =>
							link._type === "groupLinkData" ? (
								<Link
									to={link?.url}
									className="w-fit mt-3 block menu-item"
									key={link?._key}
								>
									{link.title}
								</Link>
							) : link._type === "logOutLink" ? (
								<LogOutUser
									key={link?._key}
									textColor={link.color?.hex}
									className="w-fit py-8 px-4 group-hover:flex block"
								/>
							) : null
						)}
					</div>
					{advertisement && !authenticated &&
						<div className="top-0 flex flex-col w-60 gap-2 mr-16 mt-4">
							<Image image={advertisement?.image} to={advertisement?.image?.url} className="w-60" />
							<span className="text-lg font-boldParagraph text-left">{advertisement?.title}</span>
							<span className="text-sm text-left text-wrap whitespace-normal">{advertisement?.subtitle}</span>
						</div>
					}
				</div>
			</div>
		</div>
	);
	

	const MenuLinks = () => data.map((link) => {
		switch (link._type) {
			case "groupLink":
				return <GroupLinks data={link} key={link?._key} advertisement={advertisement}/>;
			case "directLink":
				return <DirectLink data={link} key={link?._key} style="nav-link border-b-0 text-lg !py-0" />;
			case "logOutLink":
				return <LogOutUser key={link?._key} textColor={link?.color?.hex} className="nav-link" />;
			default:
				return <></>;
		}
	});

	return (
		<div className="flex justify-between items-center relative">
			<MenuLinks />
		</div>
	);
};

export default DesktopHeaderData;